<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Məbləğ</label>
            <el-input v-model.number="form.amount" size="large" type="number" placeholder="Məbləğ" disabled />
        </div>
        <div v-if="showExpense" class="mb-3">
            <label class="form-label">Əlavə xərc</label>
            <el-input v-model.number="form.expense" size="large" type="number" placeholder="Əlavə xərc" disabled />
        </div>
        <div v-if="showExpense" class="mb-3">
            <el-checkbox v-model="form.includeExpense">Əlavə xərci invoysa daxil et</el-checkbox>
        </div>
        <div class="mb-3">
            <label class="form-label">Hesab</label>
            <el-select v-model="selectedAccountId" placeholder="Seçin" size="large" filterable>
                <el-option
                    v-for="acc in accounts"
                    :key="acc.id"
                    :label="acc.displayAccountInfo || (acc.bankName + ' ' + acc.accountNumber)"
                    :value="acc.id"
                />
            </el-select>
        </div>
        <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="saveInvoice">Yadda saxla</soft-button>
            &nbsp;&nbsp;
            <soft-button type="button" color="secondary" @click="$emit('cancel')">İmtina</soft-button>
        </div>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import { CreateInvoice } from "@/project/Source/invoices";
import { GetCompanyRequisitesByType } from "@/project/Source/classifiers";

export default {
    components: { SoftButton },
    props: {
        agreedAmount: Number,
        agreementExpense: Number,
        participantId: [Number, String],
        subrogationId: [Number, String],
        showExpense: { type: Boolean, default: true } 
    },
    emits: ['saved', 'cancel'],
    data() {
        return {
            form: {
                amount: this.agreedAmount || 0,
                expense: this.agreementExpense || 0,
                includeExpense: false
            },
            accounts: [],
            selectedAccountId: null,
            loading: false
        }
    },
    watch: {
        agreedAmount(val) { this.form.amount = val },
        agreementExpense(val) { this.form.expense = val }
    },
    async mounted() {
        await this.loadAccounts();
    },
    methods: {
        async loadAccounts() {
            try {
                const type = 1;
                const resp = await GetCompanyRequisitesByType(type);
                this.accounts = resp.data.data || [];
                if (this.accounts.length === 1) {
                    this.selectedAccountId = this.accounts[0].id;
                }
            } catch {
                this.accounts = [];
                this.$message.error("Hesablar yüklənmədi");
            }
        },
        async saveInvoice() {
            const selectedAccount = this.accounts.find(x => x.id === this.selectedAccountId);

            if (!selectedAccount) {
                this.$message.warning("Hesab seçilməyib");
                return;
            }

            const item = {
                subrogationId: this.subrogationId,
                participantId: this.participantId,
                agreementAmount: this.agreedAmount,
                preAgreementExpense: (this.showExpense && this.form.includeExpense) ? this.agreementExpense : 0,
                bankName: selectedAccount.bankName,
                bankCode: selectedAccount.code,
                swift: selectedAccount.swift,
                tin: selectedAccount.tin,
                cbAccount: selectedAccount.cbAccount,
                accountNumber: selectedAccount.accountNumber,
                accountTin: selectedAccount.accountTin,
                address: selectedAccount.address
            };

            try {
                this.loading = true;
                const response = await CreateInvoice(item);
                const invoice = response.data.id;
                this.$emit("saved", invoice);
                this.$message.success("Uğurlu əməliyyat!");
            } catch (e) {
                console.error(e);
                this.$message.error(e.response?.data?.message || "Xəta baş verdi");
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
